import type { AppCtx } from './apps';

// The penalty shoot-out app. The game itself (football/game.ts: a 3D stadium, players, the ball's physics) is a
// separate chunk that downloads the first time the app opens, so the computer stays light for everyone else.

let stop: (() => void) | null = null;
let token = 0;
export function disposeFootball() { token++; stop?.(); stop = null; }

export function football(el: HTMLElement, ctx: AppCtx) {
  disposeFootball();
  const mine = token;
  el.innerHTML = '<div class="pk3 pk3-loading"><p>Floodlights on…</p></div>';
  void import('./football/game').then(({ startFootball }) => {
    if (mine !== token || !el.isConnected) return;
    stop = startFootball(el, { muted: ctx.get('sound') === 'off', click: ctx.click });
  }).catch(() => { el.innerHTML = '<div class="pk3 pk3-loading"><p>The stadium could not load. Try again.</p></div>'; });
}
